import { IKImage } from "imagekitio-next";
import React from "react";

type StoreLogoProps = {
  imageName: string;
  alt: string;
  className?: string;
};
const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;
const StoreLogoWidth = 100;
const StoreLogoHeight = 100;
const StoreLogoQuality = 100;
const StoreLogo = (props: StoreLogoProps) => {
  return (
    <IKImage
      urlEndpoint={urlEndpoint}
      path={props?.imageName || "default_image.jpg"}
      quality={StoreLogoQuality}
      transformation={[{ crop: "maintain_ratio" }]}
      width={StoreLogoWidth}
      height={StoreLogoHeight}
      alt={props?.alt}
      lqip={{ active: false, quality: 50 }}
      loading="lazy"
      className={props.className ?? "rounded-full border-2 border-orange-300 mx-2"}
    />
  );
};

export default StoreLogo;
